export default __webpack_public_path__ + "static/media/settings-selected.9901e432.svg";